import React from 'react';
import RestShow from 'containers/rest/Show';
import RestFieldItem from 'components/RestField/RestFieldItem';

const CareerRequestsShow = props => (
  <RestShow {...props} hasEdit resource="careerRequests">
    <RestFieldItem source="fullName" header="careerRequests.fullName" />
    <RestFieldItem source="desiredField" header="careerRequests.desiredField" />
    <RestFieldItem source="phoneNumber" header="careerRequests.phoneNumber" />
    <RestFieldItem source="email" header="careerRequests.email" />
    <RestFieldItem source="description" header="careerRequests.description" />
    <RestFieldItem
      source="cvUrl"
      header="careerRequests.cvUrl"
      render={(value) =>
        value ? (
          <a href={value} target="_blank" rel="noopener noreferrer">
            {value}
          </a>
        ) : (
          'N/A'
        )
      }
    />
    <RestFieldItem source="status" header="careerRequests.status" />
    <RestFieldItem source="adminNotes" header="careerRequests.adminNotes" />
  </RestShow>
);

export default CareerRequestsShow;
